import ThumbnailSlider from "./ThumbnailSlider";

export default ThumbnailSlider;
